<div class="content" role="main">
  @if (msg === '') {
    <p>Hmm... I can't find that page.</p>
  }
  @if (msg !== '') {
    <p class="alert alert-danger">You do not have permission to use Nucleus.</p>
  }
</div>
